import { render } from "./HelixAvatars.vue?vue&type=template&id=135fecf8&scoped=true"
import script from "./HelixAvatars.vue?vue&type=script&lang=js"
export * from "./HelixAvatars.vue?vue&type=script&lang=js"

import "./HelixAvatars.vue?vue&type=style&index=0&id=135fecf8&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135fecf8"]])

export default __exports__